export default __webpack_public_path__ + "static/media/trainingRecords.cd3f1695.png";